import { createAppI18n, sharedTranslations, type TKeyOf } from '@repo/i18n'
import en from '@/translations/en.json'
import it from '@/translations/it.json'

const resources = {
	en: { common: en, shared: sharedTranslations.en },
	it: { common: it, shared: sharedTranslations.it }
}

const appI18n = createAppI18n(resources, { defaultNS: 'common' })

export type TKey = TKeyOf<(typeof resources)['en']>
export const { translateApp, useTranslation } = appI18n
